import { Card } from "react-bootstrap"
import { useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import UpgradePlanList from "../PaymentButton/UpgradePlanList";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";


const AllUserAllPlanInfo = () => {

    // Redux Data
    const { currentWebsite, user } = useSelector((store: StoreProptypes) => store);
    // console.log(`test: ${currentWebsite?.current_package_only[0]?.slug}`)


    

    return (
        <>
            <Card className="aioa_dashboard-upgrade-plan-info-box mt-0">
                <Card.Body>
                    <div className="aioa_dashboard-upgrade-plan-info-box-title">
                        <div className="h4 text-primary mb-1">{("Select Plan")}</div>
                        <div className="">{("Select your desire plan based on your website pageview")}</div>
                    </div>

                    {currentWebsite && (
                        <>
                            {user && (

                                <>
                                
                                
                                    {user.department === 4 ? ( // For Partner User Only
                                        <>
                                            {(user.is_multiple_domain === 1) ? (
                                                <>
                                                    <UpgradePlanList
                                                        activePlanType={3}
                                                        activePlanDomain={currentWebsite}
                                                        activePlanInterval={'M'}
                                                        activePlanPrice={0}
                                                    />
                                                    {/* <h1>hu</h1> */}
                                                </>
                                            ) : ( // Normal Partner plan with upgrade one step up
                                                <>
                                                    <UpgradePlanList
                                                        activePlanType={1}
                                                        activePlanDomain={currentWebsite}
                                                        activePlanInterval={'M'}
                                                        activePlanPrice={0}
                                                    />
                                                </>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            {user.is_multiple_domain === 2  ? ( // Sliver Gold Plan with Add New plan 
                                                <>
                                                    <UpgradePlanList
                                                        activePlanType={2}
                                                        activePlanDomain={currentWebsite}
                                                        activePlanInterval={'M'}
                                                        activePlanPrice={0}
                                                    />
                                                </>
                                            ) : ( // Normal Plan with one stepup upgrade option
                                                <>
                                                    <UpgradePlanList
                                                        activePlanType={1}
                                                        activePlanDomain={currentWebsite}
                                                        activePlanInterval={'M'}
                                                        activePlanPrice={0}
                                                    />
                                                </>
                                            )}
                                        </>
                                    )}
                                </>
                            )}
                        </>
                    )}

                </Card.Body>
            </Card>

        </>
    )
}

export default AllUserAllPlanInfo;